/** @format */

import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { NotFoundComponent } from './not-found.component';
import { DynamicProductTemplateModule } from '../shared/dynamic-product-template-module.interface';

@NgModule({
	declarations: [NotFoundComponent],
	imports: [CommonModule, HmfTextLinkComponent],
	providers: [],
	exports: [NotFoundComponent]
})
export class NotFoundModule implements DynamicProductTemplateModule<NotFoundComponent> {
	constructor(private resolver: ComponentFactoryResolver) {}

	public resolveComponentFactory(): ComponentFactory<NotFoundComponent> {
		return this.resolver.resolveComponentFactory(NotFoundComponent);
	}
}
